export class Right {
    id!: string
    name!: string
    active!: boolean
}
